module.exports = __webpack_public_path__ + "img/oar-style.6d313607.jpg";